<div class="attendContainer">
    <div class="mainPanel reportMainPanel">
         <div class="mobtaskBtn dropup dropdown customDropdown">
            <a href="#" class="taskAddBtn dropdown-toggle" data-toggle="dropdown"><i class="material-icons">add</i></a>
            <div class="dropdown-menu dropdown-menu-right">
               <a (click)="openMarkAttenPanel();" class="dropdown-item" href="#" data-toggle="modal" data-target="#markattendModal">Mark Attendance</a>
               <a (click)="navigateToLeaveApplication()" class="dropdown-item" href="#" >Leave Application</a>                        
            </div>
         </div>
       <div class="midPanel">
       
          <div class="fullPanel">
          
             <div class="breadcrumbSec">
                <!-- <a id="naviconLeft" href="#" class="navicon"><img src="assets/img/hamburgerIcon.png" alt=""></a> -->
                <div class="breadcrumbText" hideElement>
                   <p><a href="#">Home</a> / Attendance<span *ngIf="userAttendance && userAttendance.name">/{{userAttendance.name}}</span></p>
                </div>
             </div>
             <div class="topRightSec">
                <button type="button" (click)="openMarkAttenPanel();" class="btn btn-default ripple blueBtn" 
                  data-toggle="modal" data-target="#markattendModal" *ngIf="showLeaveApplication.showMarkAttendance">
                   <i class="material-icons">touch_app</i>Mark Attendance
                </button>
                <button type="button" (click)="navigateToLeaveApplication()" class="btn btn-default ripple blueBtn" *ngIf="showLeaveApplication.showLeave">
                   <i class="material-icons">add</i>Leave Application
                </button>
                <div class="notificationDiv" [hidden]=true>
                   <a href="#"><i class="material-icons">notifications</i></a>                         
                </div>
                <!-- <ul class="mobAttnBtn">
                  <li *ngIf="userData && userData.userType != userTypeMap.FIELD_USER"><a href="#" id="emLeaveId"><img src="assets/img/attendbtn01.png" alt=""></a></li>
                  <li><a href="#" id="embirthdayId"><img src="assets/img/attendbtn02.png" alt=""></a></li>
                  <li><a href="#"><img src="assets/img/attendbtn03.png" alt=""></a></li>
               </ul> -->
             </div>
          </div>
          <router-outlet></router-outlet>
       </div>
    </div>
 </div>

 <div id="markattendModal" class="modal fade customPopup " role="dialog">
    <div class="modal-dialog modal-lg">
       <!-- Modal content-->
       <div class="modal-content">
          <div class="modal-header">
             <h3>Mark your attendance</h3>
             <a href="#" class="close-btn" data-dismiss="modal" aria-hidden="true" (click)="closeAttendancePanel()">
             <i class="material-icons">close</i>
             </a>
          </div>
          <div class="modal-body">
             <div class="formSec">
                <div class="form-group">
                   <div class="datePicker" id="reportrange">
                      <input type="text" value="" class="form-control"  (keydown)="keydown($event)" required>
                      <!-- <span></span> --><i class="material-icons">event</i>
                      <div class="floating-label">Select Date</div>
                   </div>
                </div>
                <!-- <div class="selectboxSec ">
                  <ng-select class="select form-control e1" [items]="years" bindLabel="value"
                      [virtualScroll]="true" [closeOnSelect]="true" 
                      [ngClass]="selectedYear ? 'selectfocus' : ''" name="year" placeholder="Select Year" (change)="changeYear()">
                  </ng-select>
                  
              </div> -->
                <ul class="leaveRadioList">
                   <li *ngFor="let leave of attendnaceTypeList" >
                      <label *ngIf="leave.status">
                         <input type="radio" [value]="leave" [(ngModel)]="selectedLeaveType"
                            >{{leave.name}}
                      </label>
                   </li>
                 
                </ul>
                <button type="button" class="btn btn-default ripple blueBtn" (click)="onAttendanceMark();">Submit</button>
             </div>
          </div>
       </div>
    </div>
 </div>
<!--  -->